module.exports = __webpack_public_path__ + "img/f_8.3897b210.png";